
import React from 'react'
import { InfoContainer,InfoBg, ImageBg, InfoContent, InfoP, InfoH1,
  InfoBtnWrapper, AnotherInfoContent} from './PreFooterElement'
import PreFooterImg from '../../../images/footer.png'
import Apple from "../../../images/appstore.png"
import Google from "../../../images/googleplay.png"
import "../../../App.css"
import { useTranslation } from 'react-i18next'

const PreFooter = () => {
  const {t} = useTranslation();

  return (
		<>
		<InfoContainer>
      <InfoBg>
        <ImageBg src={PreFooterImg} type='images/footer.png' />
      </InfoBg>
			<InfoContent>
        <InfoP> {t("prefoot.p1")} <br/> {t("prefoot.p2")}</InfoP>
        <InfoH1>SHARE PLUG</InfoH1>
			</InfoContent>
      <AnotherInfoContent>
        <InfoBtnWrapper>
        <a href='/logo' className='downbutton'><img src={Apple} alt='' className='downImage'></img></a>
        <a href='/logo' className='downbutton'><img src={Google} alt='' className='downImage'></img></a>
        </InfoBtnWrapper>
      </AnotherInfoContent>
      
		</InfoContainer>	
		</>
	)
}

export default PreFooter
